import { render, staticRenderFns } from "./Entidades.vue?vue&type=template&id=6c72981c&"
import script from "./Entidades.vue?vue&type=script&lang=js&"
export * from "./Entidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports